import React from "react";
import "./Features.css";
import { Card } from "primereact/card";
import { IoCheckmarkCircleSharp, IoLocationOutline } from "react-icons/io5";
import { SlCalender } from "react-icons/sl";
import { SlOrganization } from "react-icons/sl";
import { FaUsers } from "react-icons/fa";
import { MdAccessTime } from "react-icons/md";
import { GiReceiveMoney } from "react-icons/gi";
function Features() {
  return (
    <div className="Features-section">
      <h2 className="Features-heading">Our Features</h2>

      <Card className="Features-card ">
        <div className="card-icons">
          <IoLocationOutline />
        </div>
        <div className="card-headings">Attendance</div>
        <div className="card-points">
          <IoCheckmarkCircleSharp className="tick-styles" />
          <p>Geolocation Based Attendance.</p>
          <IoCheckmarkCircleSharp className="tick-styles" />
          <p>Accurate Tracking Of Working Hours.</p>
          <IoCheckmarkCircleSharp className="tick-styles" />

          <p>Easily Configurable.</p>
          <IoCheckmarkCircleSharp className="tick-styles" />

          <p>Payroll Integration.</p>
        </div>
      </Card>
      <Card className="Features-card ">
        <div className="card-icons">
          <SlCalender style={{ color: "green" }} />
        </div>
        <div className="card-headings">Leaves Management</div>
        <div className="card-points">
          <IoCheckmarkCircleSharp className="tick-styles" />
          <p>User Friendly Leave Management system.</p>
          <IoCheckmarkCircleSharp className="tick-styles" />
          <p>Unique Approval Workflow.</p>
          <IoCheckmarkCircleSharp className="tick-styles" />

          <p>Customised Leaves.</p>
          <IoCheckmarkCircleSharp className="tick-styles" />

          <p>Full-day And Half-day leaves.</p>
          <IoCheckmarkCircleSharp className="tick-styles" />

          <p>Carry Forward Leaves.</p>
        </div>
      </Card>
      <Card className="Features-card ">
        <div className="card-icons">
          <SlOrganization style={{ color: "tomato" }} />
        </div>
        <div className="card-headings">Organization </div>
        <div className="card-points">
          <IoCheckmarkCircleSharp className="tick-styles" />
          <p>Entire Organization Hirarchy.</p>
          <IoCheckmarkCircleSharp className="tick-styles" />
          <p>Reporting Hierarchy.</p>
          <IoCheckmarkCircleSharp className="tick-styles" />
          <p>Pleasing GUI Of Reporting Herarchy.</p>
        </div>
      </Card>
      
      <Card className="Features-card ">
        <div className="card-icons">
          <FaUsers style={{ color: "palevioletred" }} />
        </div>
        <div className="card-headings">Employees Management </div>
        <div className="card-points">
          <IoCheckmarkCircleSharp className="tick-styles" />
          <p>Comprehensive Employee Profile Management.</p>
          <IoCheckmarkCircleSharp className="tick-styles" />
          <p>Centralized information repository of all employees.</p>
          <IoCheckmarkCircleSharp className="tick-styles" />

          <p>Onboarding and Exit management.</p>
          <IoCheckmarkCircleSharp className="tick-styles" />
          <p>Manage the Employee Life cycle related documents.</p>
        </div>
      </Card>
      <Card className="Features-card ">
        <div className="card-icons">
          <MdAccessTime style={{ color: "#e65100" }} />
        </div>
        <div className="card-headings">Shift Management </div>
        <div className="card-points">
          <IoCheckmarkCircleSharp className="tick-styles" />
          <p>All your complex shift management covered.</p>

          <IoCheckmarkCircleSharp className="tick-styles" />

          <p>Project Based Shifts Planning.</p>
          <IoCheckmarkCircleSharp className="tick-styles" />

          <p>User Friendly Shift Configuration.</p>
          <IoCheckmarkCircleSharp className="tick-styles" />

          <p>Holiday Calendar and Weekly-Off Planning.</p>
        </div>
      </Card>
      <Card className="Features-card ">
        <div className="card-icons">
          <GiReceiveMoney style={{ color: "orange" }} />
        </div>
        <div className="card-headings">Payroll Management </div>
        <div className="card-points">
          <IoCheckmarkCircleSharp className="tick-styles" />
          <p>Run Payroll anytime, anywhere.</p>

          <IoCheckmarkCircleSharp className="tick-styles" />

          <p>Expense Tracker And Reimbursement.</p>
          <IoCheckmarkCircleSharp className="tick-styles" />

          <p>Custom Reimbursement approval workflows.</p>
          <IoCheckmarkCircleSharp className="tick-styles" />

          <p>Integrated with Attendance, Leaves and Expenses.</p>

          <IoCheckmarkCircleSharp className="tick-styles" />

          <p>Generation of Payslips, Bank Files.</p>

          <IoCheckmarkCircleSharp className="tick-styles" />

          <p>Investment Declaration.</p>
        </div>
      </Card>
    </div>
  );
}

export default Features;
